import formatcoords from "formatcoords";
import { i18n } from "@/main";
import { CFS_URL } from "@/helpers";
import { USER_TYPE } from "@/const.js";
import swal from "sweetalert2";
import { router } from "@/main";


export function mapPopupTpl(feature, usertype) {
  let tpl = ''

  if (feature.properties.TYPE) {
    let cfs = ''
    window.freeUserNoCFSAccessTip = () => {
      swal
        .fire({
          title: i18n.t("Warning"),
          text: i18n.t("Upgrade your plan to get unlimited access to the CFS"),
          type: "warning",
          confirmButtonClass: "md-button md-success",
          cancelButtonClass: "md-button md-danger",
          confirmButtonText: i18n.t("Yes"),
          cancelButtonText: i18n.t("Cancel"),
          buttonsStyling: false,
          showCancelButton: true,
        })
        .then(({ value }) => {
          if(value) {
            router.push("/Subscription");
          }
        });
    }
    if (feature.properties.CFS_LINK) {
      if (usertype === USER_TYPE.FREE) {
        cfs = `<a href="javascript:void(0)" onclick="window.freeUserNoCFSAccessTip()">${i18n.t('CFS')}</a>`
      } else {
        cfs = `<a target="_blank" href="${CFS_URL}${feature.properties.CFS_LINK}">${i18n.t('CFS')}</a>`
      }
      
    }

    tpl = `
      <div style="font-weight: 600;">${feature.properties.NAME}&nbsp;&nbsp;${feature.properties.id}</div>
      <div>${i18n.t("Type")}: ${feature.properties.TYPE}</div>
      <div>${i18n.t("Operator")}: ${feature.properties.OPR_TYPE}</div>
      <div>
        ${i18n.t("Location")}: ${formatcoords(
      +feature.properties.LATITUDE,
      +feature.properties.LONGITUDE,
    ).format('DDMMssX', {
      latLonSeparator: ', ',
      decimalPlaces: 0,
    })}
      </div>
      <div>${i18n.t("Elevation")}: ${feature.properties.ELEVATION}&nbsp;${i18n.t('ft')}</div>
      <div>${cfs}</div>
      <br/>
    `
  } else if (feature.properties.CLASS) {
    tpl = `
      <div style="font-weight: 600;">${feature.properties.NAME}</div>
      <div>${i18n.t("Class")}: ${feature.properties.CLASS}</div>
      <div>${i18n.t("Floor")}: ${feature.properties.FLOOR}</div>
      <div>${i18n.t("Ceiling")}: ${feature.properties.CEILING}</div>
      <br/>
    `
  } else if (feature.properties.ZONE) {
    tpl = `
      <div style="font-weight: 600;">${feature.properties.NAME}</div>
      <div>${i18n.t("Zone")}: ${feature.properties.ZONE}</div>
      <br/>
    `
  }

  return tpl
}